import { render, staticRenderFns } from "./GStarOff.vue?vue&type=template&id=6ab851fa&"
import script from "./GStarOff.vue?vue&type=script&lang=js&"
export * from "./GStarOff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports